<template>
  <div>
    <table>
      <tbody>
      <tr>
        <td class="hh" colspan="2">Term - {{ _term_name }}</td>
        <td class="hh">Machine 1</td>
        <td class="hh">Machine 2</td>
        <td class="hh">Machine 3</td>
        <td class="hh">Machine 4</td>
      </tr>
      <tr>
        <td class="h"></td>
        <td class="h">CURRENT PRICING</td>
        <td class="h">PITNEY BOWES RATES VIA DMS</td>
        <td class="h">QUADIENT (NEOPOST) RATES VIA DMS</td>
        <td class="h">FP RATES VIA DMS</td>
        <td class="h">FRAMA RATES VIA DMS</td>
      </tr>
      <tr>
        <td class="h">MACHINE MODEL:</td>
        <td class="h">Current model</td>
        <td class="h">New Costs Machine 1 model</td>
        <td class="h">New Costs Machine 2 model</td>
        <td class="h">New Costs Machine 3 model</td>
        <td class="h">New Costs Machine 4 model</td>
      </tr>
      <tr>
        <td class="h">Proposed Costs</td>
        <td> {{ (getCurrentCostValue('equipment_lease_costs') / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ (getCostValueByTerm(man, 'total_equipment_cost') - getCostValueByTerm(man, 'settlement_cost')).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Settlement Costs</td>
        <td>N/A</td>
        <td v-for="man in [2,3,4,5]">{{ getCostValueByTerm(man, 'settlement_cost').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Proposed Service Costs</td>
        <td> {{ (getCurrentCostValue('service_costs') / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ getCostValueByTerm(man, 'total_service_cost').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">TOTAL PROPOSED COST INCLUDING SERVICE YEAR ONE</td>
        <td> {{ ((getCurrentCostValue('equipment_lease_costs') + getCurrentCostValue('service_costs')) / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ (getCostValueByTerm(man, 'total_equipment_cost') + getCostValueByTerm(man, 'settlement_cost') + getCostValueByTerm(man, 'total_service_cost')).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Invoice Fees</td>
        <td> {{ ((getCurrentCostValue('invoice_fees')) / 4).toFixed(2) }}</td>
        <td>N/A</td>
        <td>N/A</td>
        <td>N/A</td>
        <td>N/A</td>
      </tr>
      <tr>
        <td class="h">Insurance Fees</td>
        <td> {{ ((getCurrentCostValue('insurance_fees')) / 4).toFixed(2) }}</td>
        <td>N/A</td>
        <td>N/A</td>
        <td>N/A</td>
        <td>N/A</td>
      </tr>
      <tr>
        <td class="h">Postage Reset Fees</td>
        <td> {{ ((getCurrentCostValue('postage_recredit_costs')) / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ getCostValue(man, 'postage_recredit_costs').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Consumable Ink Costs</td>
        <td> {{ ((getCurrentCostValue('consumable_ink_costs')) / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ getCostValue(man, 'consumables_ink_cost').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Consumable Label Costs</td>
        <td> {{ ((getCurrentCostValue('consumable_label_costs')) / 4).toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ getCostValue(man, 'consumable_label_cost').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">Postage Savings</td>
        <td></td>
        <td v-for="man in [2,3,4,5]">{{ getCostValue(man, 'postage_savings').toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">TOTAL INVESTMENT PER QUARTER</td>
        <td> {{ (getTotalInvestmentPerAnnumForCurrent() / 4).toFixed(2) }} </td>
        <td v-for="man in [2,3,4,5]"> {{ (getTotalInvestmentPerAnnumForMachine(man) / 4).toFixed(2) }} </td>
      </tr>
      <tr>
        <td class="h">TOTAL INVESTMENT PER ANNUM</td>
        <td>{{ getTotalInvestmentPerAnnumForCurrent().toFixed(2) }}</td>
        <td v-for="man in [2,3,4,5]">{{ getTotalInvestmentPerAnnumForMachine(man).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">TOTAL SAVINGS VS CURRENT AGREEMENT OVER TERM</td>
        <td>N/A</td>
        <td v-for="man in [2,3,4,5]">{{ ((getTotalInvestmentPerAnnumForCurrent() - getTotalInvestmentPerAnnumForMachine(man)) * (term ? (term + 1) : 5)).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="h">DEAL MARGIN</td>
        <td>N/A</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    name: 'lease-options-table',
    props: ['term', 'costs', 'current_costs'],
    computed: {
      _term_name() {
        if (this.term === false) return 'purchase'

        return this.term + 1
      },
    },
    methods: {
      getMan(id) {
        return _.find(this.costs, c => {
          return c.manufacturer.id === id
        }) || false
      },
      getCostValue(manufacturer_id, key) {
        let man = this.getMan(manufacturer_id)
        if (!man) return 0
        return man[key]
      },
      getCostValueByTerm(manufacturer_id, key, term = null) {
        term = term ? term : this.term
        let man = this.getMan(manufacturer_id)
        if (!man) return 0
        if (term === false) return man[key]['purchase']
        return man[key]['lease'][term]
      },
      getCurrentCostValue(key) {
        return this.current_costs[key]
      },
      getTotalInvestmentPerAnnumForCurrent() {
        return (this.getCurrentCostValue('consumable_label_costs') +
          this.getCurrentCostValue('consumable_ink_costs') +
          this.getCurrentCostValue('postage_recredit_costs') +
          this.getCurrentCostValue('insurance_fees') +
          this.getCurrentCostValue('invoice_fees') +
          this.getCurrentCostValue('service_costs') +
          this.getCurrentCostValue('equipment_lease_costs')
        )
      },
      getTotalInvestmentPerAnnumForMachine(man) {
        return this.getCostValue(man, 'postage_savings') +
          this.getCostValue(man, 'consumable_label_cost') +
          this.getCostValue(man, 'consumables_ink_cost') +
          this.getCostValue(man, 'postage_recredit_costs') +
          this.getCostValueByTerm(man, 'total_service_cost') +
          this.getCostValueByTerm(man, 'settlement_cost') +
          this.getCostValueByTerm(man, 'total_equipment_cost')
      },
    }
  }
</script>
<style lang="scss" scoped>
table {
  margin-top: 50px;
  width: 100%;

  &:last-child {
    margin-bottom: 50px;
  }

  tr:nth-child(n+4):hover {
    td {
      color: #0a70e3;
    }
  }

  td {
    border: 1px solid darken(#f2f2f2, 20%);
    padding: 10px;
    line-height: 1.3;
    vertical-align: middle;
    font-size: 14px;

    &.hh {
      font-weight: 700;
      color: #b50a78;
    }

    &.h {
      background-color: #f2f2f2;
      font-weight: 700;
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ProposalTemplate/Partials/LeaseOptionsTable.vue